interface Config {
  apiUrl: string;
  signInUrl: string;
  signOutUrl: string;
}

export const config: Config = {
  apiUrl: process.env.REACT_APP_API_URL || "https://tatai-copilot.tat.or.th/be",
  signInUrl:
    process.env.REACT_APP_SIGN_IN_URL ||
    "https://auth.tat.or.th/oauth2/sign_in?rd=https://tatai-copilot.tat.or.th",
  signOutUrl:
    process.env.REACT_APP_SIGN_OUT_URL ||
    "https://auth.tat.or.th/oauth2/oauth2/sign_out",
};

// Validate required environment variables
const validateConfig = () => {
  const requiredVars = [{ key: "apiUrl", value: config.apiUrl }];

  const missingVars = requiredVars
    .filter(({ value }) => !value)
    .map(({ key }) => key);

  if (missingVars.length > 0) {
    console.error(
      `Missing required environment variables: ${missingVars.join(", ")}\n` +
        "Please check your .env file"
    );
  }
};

// Run validation
validateConfig();

export default config;
